import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TOrderPayload } from '../../../../types/order/TOrderPayload';
import { IStandardDocumentVersionData, IStandardDocumentCategoryData } from 'types/order/documents/shared/interfaces';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { adminDocumentsInitialState } from './interfaces';

export const adminDocumentsReducer = createSlice({
  name: 'adminDocuments',
  initialState: adminDocumentsInitialState,
  reducers: {
    setDocumentCategoriesActions: (state, action: PayloadAction<IStandardDocumentCategoryData[]>) => {
      state.categories = action.payload;
    },
    setAdminDocumentsDataAction: (state, action: PayloadAction<TOrderPayload<IStandardDocumentVersionData[]>>) => {
      state.documents[action.payload.orderId] = action.payload.value;
    },
    setAdminDocumentsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.documentsFetchStatus = action.payload;
    },
    setAdminDocumentsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.documentsError = action.payload;
    },
    setDocumentsActionFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.documentsActionFetchStatus = action.payload;
    },
    setUploadDocumentErrorAction: (state, action: PayloadAction<string | null>) => {
      state.uploadDocumentsError = action.payload;
    },
    setUploadDocumentFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.uploadDocumentsFetchStatus = action.payload;
    },
    setEditDocumentErrorAction: (state, action: PayloadAction<string | null>) => {
      state.editDocumentsError = action.payload;
    },
    setEditDocumentFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.editDocumentsFetchStatus = action.payload;
    },
    setDocumentsActionErrorAction: (state, action: PayloadAction<string | null>) => {
      state.documentsActionError = action.payload;
    },
    setAdminDocumentHistoryDataAction: (
      state,
      action: PayloadAction<TOrderPayload<IStandardDocumentVersionData[]>>
    ) => {
      state.documentHistory[action.payload.orderId] = action.payload.value;
    },
    setDocumentHistoryFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.documentsHistoryFetchStatus = action.payload;
    },
    setDocumentHistoryErrorAction: (state, action: PayloadAction<string | null>) => {
      state.documentsHistoryError = action.payload;
    },
    setMergeDocumentsFetchStatusAction: (state, action: PayloadAction<IFetchStatus>) => {
      state.mergeDocumentsFetchStatus = action.payload;
    },
    setMergeDocumentsErrorAction: (state, action: PayloadAction<string | null>) => {
      state.mergeDocumentsError = action.payload;
    },
    setDocumentDetailsAction: (state, action: PayloadAction<IStandardDocumentVersionData | null>) => {
      state.documentDetails = action.payload;
    },
  },
});

export const {
  setAdminDocumentsDataAction,
  setAdminDocumentsFetchStatusAction,
  setAdminDocumentsErrorAction,
  setDocumentsActionFetchStatusAction,
  setDocumentsActionErrorAction,
  setUploadDocumentErrorAction,
  setUploadDocumentFetchStatusAction,
  setEditDocumentErrorAction,
  setEditDocumentFetchStatusAction,
  setAdminDocumentHistoryDataAction,
  setDocumentHistoryErrorAction,
  setDocumentHistoryFetchStatusAction,
  setMergeDocumentsFetchStatusAction,
  setMergeDocumentsErrorAction,
  setDocumentCategoriesActions,
  setDocumentDetailsAction,
} = adminDocumentsReducer.actions;
